import React from 'react';
import { APP_LOGO_ALT, APP_LOGO_SRC } from '../../constants/brandAssets';

type BrandLogoProps = {
    className?: string;
    imageClassName?: string;
    showWordmark?: boolean;
    wordmarkClassName?: string;
    size?: number;
};

const BrandLogo: React.FC<BrandLogoProps> = ({
    className = '',
    imageClassName = '',
    showWordmark = true,
    wordmarkClassName = '',
    size = 36,
}) => (
    <span className={`brand-logo ${className}`.trim()}>
        <img
            src={APP_LOGO_SRC}
            alt={APP_LOGO_ALT}
            className={`brand-logo__image ${imageClassName}`.trim()}
            width={size}
            height={size}
            decoding="async"
        />
        {showWordmark && (
            <span className={`brand-logo__wordmark ${wordmarkClassName}`.trim()}>{APP_LOGO_ALT}</span>
        )}
    </span>
);

export default BrandLogo;
